module.exports = __webpack_public_path__ + "img/btw-service-icon.b00cf1ca.svg";